import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { COLOR } from '../utils/theme.utils';

@Injectable({
  providedIn: 'root'
})
export class ThemeWrapper {
  readonly ionColorBackground = this.getThemeColor('--ion-color-background');

  constructor(@Inject(DOCUMENT) private document: Document) {}

  private getThemeColor(property: string): COLOR {
    let color = getComputedStyle(this.document.documentElement).getPropertyValue(property);
    color = color.trim();

    return color as COLOR;
  }
}
